export const SET_BOARDS = "SET_BOARDS";
export const SET_SELECTED_BOARD_ID = "SET_SELECTED_BOARD_ID";
export const SET_STEPS = "SET_STEPS";
export const SET_TASKS = "SET_TASKS";
export const SET_KANBAN_LOADING = "SET_KANBAN_LOADING";
export const SET_BOARDS_LOADED = "SET_BOARDS_LOADED";
export const SET_BOARDS_FETCH_FAILED = "SET_BOARDS_FETCH_FAILED";
export const INCREMENT_BOARDS_REQUEST_VERSION =
	"INCREMENT_BOARDS_REQUEST_VERSION";
export const RESET_KANBAN_ACCOUNT_STATE = "RESET_KANBAN_ACCOUNT_STATE";
export const ADD_TASK = "ADD_TASK";
export const UPDATE_TASK = "UPDATE_TASK";
export const MOVE_TASK = "MOVE_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const UPDATE_STEP = "UPDATE_STEP";
export const ADD_STEP = "ADD_STEP";
export const ADD_BOARD = "ADD_BOARD";
export const UPDATE_BOARD = "UPDATE_BOARD";
export const DELETE_BOARD = "DELETE_BOARD";
export const SET_KANBAN_PREFERENCES = "SET_KANBAN_PREFERENCES";

// Step-based task loading
export const SET_STEP_TASKS = "SET_STEP_TASKS";
export const APPEND_STEP_TASKS = "APPEND_STEP_TASKS";
export const SET_STEP_LOADING = "SET_STEP_LOADING";
export const SET_STEP_META = "SET_STEP_META";
export const RESET_STEP_TASKS = "RESET_STEP_TASKS";
export const INCREMENT_STEP_REQUEST_VERSION = "INCREMENT_STEP_REQUEST_VERSION";
export const INCREMENT_STEPS_REQUEST_VERSION =
	"INCREMENT_STEPS_REQUEST_VERSION";

// Products
export const SET_PRODUCTS = "SET_PRODUCTS";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
